import React, {FC, ReactElement, useState, useEffect, useMemo} from 'react';
import './Front.scss';
import Slide from './library/slide/Slide';
import {environmentProd} from './environments/environment.prod';
import {environmentStaging} from './environments/environment.staging';

type appProps = {
    originalData: any
}

declare global {
    interface Window {
        environmentLink: string;
        activeSlideIndex: number;
        disableScroll: boolean;
    }
}


const Front: FC<appProps> = ({...props}): ReactElement => {

    const environmentObj = process.env.REACT_APP_ENV === 'staging' ? environmentStaging : environmentProd;
    const environmentLink: any = environmentObj.assetsLink;
    const [ isPreviewBadge, setPreviewBadge ] = useState(false);
    const [progressBarWidth, setProgressBarWidth] = useState(0);
    const isDisableEvents = window.location.href.indexOf('preventEvents=true') > -1;
    const partialOrgInfo = props.originalData.orgInfo;

    useEffect(() => {
        if (window.location.href.indexOf('removeBadge') > -1 || window.location.href.indexOf('preview=false') > -1) {
            removePreviewBadge();
        }

        if (window.location.href.indexOf('preview=true') > -1
            || window.location.href.indexOf('/version-preview/') > -1
            || (window.location.href.indexOf('/preview/') > -1 && window.location.href.indexOf('preview=false') <= -1)) {
            setPreviewBadge(true);
        }

        if (window.activeSlideIndex && window.activeSlideIndex !== 0 && window.location.search.indexOf('scrollToSlide=true') > -1) {
            let slides = document.querySelectorAll('.slide');
            if (slides) {
                let slide = slides[window.activeSlideIndex] as HTMLElement;
                if (slide) setTimeout(() => slide.scrollIntoView(), 500)
            }
        }

        // detectAnchorClicks();
    }, [props.originalData]);

    function removePreviewBadge() {
        setPreviewBadge(false);
    }

    function detectAnchorClicks() {
        const anchorsTriggers = document.querySelectorAll('[data-anchor-trigger]');
        anchorsTriggers.forEach(function (anchorTrigger) {
            anchorTrigger.addEventListener("click", (event) => {
                const triggerElement:any = event.currentTarget;
                if(!triggerElement) return;
                event.stopPropagation();
                const currentTrigger = triggerElement.getAttribute('data-anchor-trigger');
                const anchorTargetElement:HTMLElement|null = document.querySelector('[data-anchor-target="'+currentTrigger+'"]');
                if(!anchorTargetElement) return;
                const anchorTarget = anchorTargetElement.getAttribute('data-anchor-target');
                let elementPos = anchorTargetElement.offsetTop - 140;
                if(currentTrigger === anchorTarget) {
                    window.scrollTo({
                        top: elementPos,
                        behavior: 'smooth',
                    });
                }
            });
        })
    }


    // Scroll bar
    window.onscroll = function () {
        initScrollbar();
    };

    function initScrollbar() {
        let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        let height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        let scrolled = (winScroll / height) * 100;
        setProgressBarWidth(scrolled);
    }

    return (props.originalData &&
        <div id={'frontView'}>
            <div className={'story ' + (isDisableEvents ? 'disableEvents ' : '') + (isPreviewBadge ? 'withPreviewBadge' : '')}>
                {
                    !partialOrgInfo?.hideHeaderBadge && <div className="storydocBadge">
                        <a href="https://www.storydoc.com/presentation-maker?utm_source=story&amp;utm_medium=header&amp;utm_campaign=QA&amp;utm_content=QA" target="_self">
                            <p>Powered by</p>
                            <img data-src="https://assets.storydoc.com/assets/storydoc-logo.png" alt="Storydoc" src="https://assets.storydoc.com/assets/storydoc-logo.png"/>
                        </a>
                    </div>
                }
                <div className="progress-bar" id="myBar" style={{maxWidth: progressBarWidth + '%'}}></div>
                {isPreviewBadge && <div className="storyPreviewBanner">
                    <p className={'title'}>This is a preview of your story</p>
                    <div className="close" onClick={() => removePreviewBadge()}><img src={environmentLink + '/assets/images/close-white.svg'} alt=""/></div>
                </div>}
                <div className="storyContent">
                    {
                        props.originalData.slides.map((slide: any, index: number) => {
                            const backgroundColor = props.originalData.settings.designSystemV2 && props.originalData.settings.designSystemV2.backgroundColor ? props.originalData.settings.designSystemV2.backgroundColor : '#ffffff';
                            const backgroundColor2 = props.originalData.settings.designSystemV2 && props.originalData.settings.designSystemV2.backgroundColor2 ? props.originalData.settings.designSystemV2.backgroundColor2 : '#e5f2fe';
                            return (
                                <Slide {...slide} key={index} defaultBackgroundColor={backgroundColor} defaultBackgroundColor2={backgroundColor2}/>
                            );
                        })
                    }
                </div>
                {
                    !partialOrgInfo?.hideFooterBadge && <footer className="storydoc-badge-footer">
                        <a href="https://www.storydoc.com/presentation-maker?utm_source=story&amp;utm_medium=header&amp;utm_campaign=QA&amp;utm_content=QA" target="_self">
                            <p>Got a story to tell? Check out</p>
                            <img data-src="https://assets.storydoc.com/assets/storydoc-logo.png" alt="StoryDoc" src="https://assets.storydoc.com/assets/storydoc-logo.png"/>
                        </a>
                    </footer>
                }
            </div>
        </div>
    );
};
export default Front;
